import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from "app/app.config";

import { APIService } from 'app/services/api.service';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'app/services/auth.service';

@Component({
  selector: 'no-portfolio-modal',
  standalone: true,
  templateUrl: 'NoPortfolioModal.component.html',
})
export class NoPortfolioModalComponent {
  activeModal = inject(NgbActiveModal);

  @Input() name = '';
}

@Component({
  selector: 'mobile-app-modal',
  standalone: true,
  templateUrl: 'MobileAppModal.component.html',
})
export class MobileAppModalComponent {
  config = inject(AppConfig);
  activeModal = inject(NgbActiveModal);

  @Input() name = '';
}

@Component({
  standalone: true,
  templateUrl: 'PgfAnnounceModal.component.html',
})
export class PgfAnnounceModalComponent {
  activeModal = inject(NgbActiveModal);
}

@Component({
  standalone: true,
  templateUrl: 'PgfWelcomeModal.component.html',
})
export class PgfWelcomeModalComponent {
  activeModal = inject(NgbActiveModal);
}

@Component({
    imports: [NgbTooltipModule],
    templateUrl: 'WelcomeNotificationModal.component.html'
})
export class WelcomeNotificationModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  private api = inject(APIService);
  private config = inject(AppConfig);
  auth = inject(AuthenticationService);

  @Input() notificationMsg: string = '';
  @Input() notificationFlaggedMsg: string = '';
  @Input() notifcationIds: number[] = [];
  @Input() nameId: string = '';
  public isImpersonated = false;

  ngOnInit(): void {
    this.isImpersonated = !!sessionStorage.getItem('guid');
  }

  dismissNotice() {
    const formData = {
      nameId: this.nameId,
      NotificationIdList: JSON.stringify(this.notifcationIds)
    }

    this.api.post(this.config.profile.markNotificationsDoNotShowUrl,
      formData
    ).subscribe(()=>{this.auth.loadNewNotificationsCount();});
    this.activeModal.dismiss('submit');
  }

}